import React, { useState, useEffect, forwardRef } from "react";

const CookieModal = forwardRef(({ initialConsent, onClose }, ref) => {
  const [consent, setConsent] = useState(
    initialConsent || (() => {
      const stored = localStorage.getItem("cookieConsentV2");
      return stored ? JSON.parse(stored) : {
        essential: true,
        statistics: false,
        media: false,
      };
    })
  );

  const handleToggle = (key) => {
    setConsent((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const saveConsent = () => {
    localStorage.setItem("cookieConsentV2", JSON.stringify(consent));
    if (onClose) onClose();
  };

  useEffect(() => {
    if (initialConsent) setConsent(initialConsent);
  }, [initialConsent]);

  return (
    <div
      className="fixed inset-0 bg-[#121212]/90 backdrop-blur-sm flex items-center justify-center z-[100]"
      onClick={(e) => {
        if (ref && ref.current && !ref.current.contains(e.target)) {
          saveConsent();
        }
      }}
    >
      {/* Terminal-Fenster */}
      <div
        ref={ref}
        className="w-[95%] max-w-lg rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40 font-mono"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title Bar */}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
          <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
          <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
          <span className="w-3 h-3 rounded-full bg-[#28c840]" />
          <span className="ml-3 text-xs text-[#EFEBDC]/40 select-none">cookies</span>
        </div>

        {/* Terminal Content */}
        <div className="px-4 sm:px-6 py-5 bg-[#151515]">

          <p className="text-sm text-[#EFEBDC]/50">
            <span className="text-[#AC8E66]">$</span> cookie --config
          </p>
          <p className="text-xs text-[#EFEBDC]/40 mt-2 leading-relaxed">
            <span className="text-[#AC8E66]/60">&gt;</span> Cookies, um Funktionen bereitzustellen und dein Nutzungserlebnis zu verbessern.{" "}
            <a href="/datenschutz" className="underline text-[#AC8E66]/70 hover:text-[#AC8E66]" target="_blank" rel="noopener noreferrer">
              Datenschutzerklärung
            </a>.
          </p>

          {/* Cookie-Optionen */}
          <div className="mt-5 space-y-0">

            {/* Essentiell */}
            <div className="flex justify-between items-center border-b border-[#AC8E66]/10 py-3">
              <span className="text-xs text-[#EFEBDC]/80">
                <span className="text-green-400/70">&gt;</span> essentiell
              </span>
              <span className="text-xs text-green-400 italic">aktiv</span>
            </div>

            {/* Statistik */}
            <div className="flex justify-between items-center border-b border-[#AC8E66]/10 py-3">
              <span className="text-xs text-[#EFEBDC]/80">
                <span className="text-[#AC8E66]/70">&gt;</span> statistik (matomo)
              </span>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={consent.statistics}
                  onChange={() => handleToggle("statistics")}
                  className="sr-only"
                />
                <div className={`w-9 h-5 rounded-full relative transition ${consent.statistics ? "bg-green-500/30" : "bg-[#EFEBDC]/10"}`}>
                  <div
                    className={`w-4 h-4 rounded-full shadow-md absolute top-0.5 left-0.5 transition-transform ${
                      consent.statistics ? "translate-x-4 bg-green-400" : "bg-[#EFEBDC]/40"
                    }`}
                  />
                </div>
              </label>
            </div>

            {/* Medien */}
            <div className="flex justify-between items-center py-3">
              <span className="text-xs text-[#EFEBDC]/80">
                <span className="text-[#AC8E66]/70">&gt;</span> externe medien (youtube, github, instagram)
              </span>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={consent.media}
                  onChange={() => handleToggle("media")}
                  className="sr-only"
                />
                <div className={`w-9 h-5 rounded-full relative transition ${consent.media ? "bg-green-500/30" : "bg-[#EFEBDC]/10"}`}>
                  <div
                    className={`w-4 h-4 rounded-full shadow-md absolute top-0.5 left-0.5 transition-transform ${
                      consent.media ? "translate-x-4 bg-green-400" : "bg-[#EFEBDC]/40"
                    }`}
                  />
                </div>
              </label>
            </div>
          </div>

          {/* Save Button */}
          <button
            onClick={saveConsent}
            className="mt-5 w-full py-2.5 text-xs text-[#AC8E66] bg-[#1c1c1c] border border-[#AC8E66]/30 rounded-md hover:border-[#AC8E66]/60 transition-colors cursor-pointer font-mono"
          >
            [ save --cookies → ]
          </button>
        </div>
      </div>
    </div>
  );
});

export default CookieModal;
